import React from "react";
import "./CSS/Categories.css";
import { useNavigate } from "react-router-dom";

import crdbg from "./IMAGES/030baf24263fe4ae6abe7c3522b06880211742a7.png";
import saree from "./IMAGES/Category Saree.png";
import kurti from "./IMAGES/Category Kurtis.png";
import dresses from "./IMAGES/Category Dresses.png";
import tops from "./IMAGES/Category Tops.png";

const Categories = () => {
  const navigate = useNavigate();

  const data = [
    { id: 1, title: "Sarees", img: saree, bg: crdbg },
    { id: 2, title: "Dresses", img: dresses, bg: crdbg },
    { id: 3, title: "Kurti", img: kurti, bg: crdbg },
    { id: 5, title: "Tops", img: tops, bg: crdbg },
  ];

  const handleCategoryClick = (category) => {
    navigate(`/shop?categoryId=${category.id}`, {
      state: {
        categoryId: category.id,
        categoryName: category.title,
      },
    });
  };

  return (
    <div className="categories-container">
      {/* ================= HEADER ================= */}

      <div className="categories-header">
        <div>
          <h1>Exclusive Categories</h1>

          <p>
            Explore our handcrafted collections, tailored for every generation.
          </p>
        </div>
      </div>

      {/* ================= CATEGORY LIST ================= */}

      <div className="categories-card-wrapper">
        {data.map((item) => (
          <div
            className="categories-card"
            key={item.id}
            role="button"
            tabIndex={0}
            onClick={() => handleCategoryClick(item)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                handleCategoryClick(item);
              }
            }}
          >
            {/* IMAGE CIRCLE */}

            <div
              className="category-circle"
              style={{ backgroundImage: `url(${item.bg})` }}
            >
              <img src={item.img} alt={item.title} />
            </div>

            {/* CATEGORY NAME */}

            <p className="category-name">{item.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Categories;
